// Bilderna och videorna i artiklarna sparas med adressen relativt API:t (help/media/{id}), så att samma artikel fungerar
// i alla miljöer. Den här miljöns API-adress, med avslutande snedstreck så att relativa adresser hamnar under /api/v1/.
const apiUrl = process.env.REACT_APP_API_URL ?? '';
export const HELP_MEDIA_BASE_URL = apiUrl.endsWith('/') ? apiUrl : `${apiUrl}/`;

const relativeMediaSrc = /(\ssrc=)(["'])help\/media\//g;

// Gör adresserna absoluta mot den här miljöns API vid visning (img och videons source).
export const resolveHelpMediaUrls = (html: string) => html.replace(relativeMediaSrc, `$1$2${HELP_MEDIA_BASE_URL}help/media/`);
